import React, { useCallback } from "react";
import { ReactComponent as Search } from "assets/svgs/search.svg";
import debounce from "helpers/debounce";
import { trackSearchBlogs } from "services/analytics";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import { useGlobalContext } from "context/global";

const SearchBlogs = ({ input, setInput, isOpen, toggle }) => {
	const { translation } = useGlobalContext();

	const handleChange = (e) => {
		const search = e.target.value;
		setInput(e.target.value.toLowerCase());
		search && debouncedResults(search);
	};

	const clearInput = () => {
		setInput("");
		toggle();
	};

	const debouncedResults = useCallback(
		debounce((text) => trackSearchBlogs(text), 1000),
		[],
	);

	return isOpen ? (
		<div className="flex items-center w-11/12 lg:w-1/2">
			<input
				autoFocus
				onChange={handleChange}
				onKeyDown={(e) => e.key === "Escape" && clearInput()}
				className="border-b-[1px] py-3 border-black focus:outline-none w-full"
				type="text"
				value={input}
				aria-label={translation.blog?.search_placeholder}
				placeholder={translation.blog?.search_placeholder}
			/>
			<button className="animate-fade-in" onClick={toggle}>
				<Close className="w-5 h-5 cursor-pointer"/>
			</button>
		</div>
	) : (
		<button className="animate-fade-in flex self-center mr-5" onClick={toggle}>
			<Search className="w-8 h-8 cursor-pointer" />
		</button>
	);
};

export default SearchBlogs;
